/* eslint-disable react/jsx-filename-extension */
import "whatwg-fetch";

export function wrapRootElement({ element }) {
  return element;
}
